/**
 * Lightweight variable binding types and key identity for the graphing suite.
 *
 * Separated from variableRef.ts so that slices (like recorderSlice) and the store
 * do not pull in heavy presentation/result lifecycles and solver trees.
 */

export type VariableSource = 'param' | 'result' | 'stream';

export interface VariableRef {
  /** Canvas node id — or, for `source:'stream'`, the EO edge id (`A__to__B` / `feed__X` / `open__X`). */
  nodeId: string;
  /** Field path within `node.data` (`'speed'`, `'params.T_out'`) or the stream field (`'T_C'`…). */
  field: string;
  source: VariableSource;
  /** Human label captured at listing time, e.g. `"Feed Pump · Speed"`. Display-only. */
  label: string;
  /** Display unit (e.g. `'°C'`, `'kPa'`, `'kg/s'`, `'MW'`, `'-'`). Display-only. */
  unit: string;
}

/** Drag-and-drop payload mime for a JSON-serialized {@link VariableRef}. */
export const VARREF_MIME = 'application/x-datacrate-varref';

/** Stable identity for a binding — used as the recorder series key. */
export function refKey(ref: Pick<VariableRef, 'source' | 'nodeId' | 'field'>): string {
  return `${ref.source}:${ref.nodeId}:${ref.field}`;
}
